import { useMainStore } from './useMainStore'

export const useIsSessionExpired = () => useMainStore(({ isSessionExpired }) => isSessionExpired)

export const useIsAuthenticatedWithDifferentUser = () =>
  useMainStore(({ isAuthenticatedWithDifferentUser }) => isAuthenticatedWithDifferentUser)

export const useMainStoreActions = () => useMainStore(state => state.actions)
